export default "__VITE_ASSET__CB3f3$AG__"